import { dcFactory } from 'dc';
import ReadMoreComponent from './js/read-more.component';

dcFactory.register(ReadMoreComponent);
